//The contents of this file have been generated automatically. Do not edit this file.

import * as t from 'io-ts';
import { isRight } from 'fp-ts/lib/Either';
import { fetchGeneralRaw, FetchGeneralRawResponseType } from 'src_common/common/fetch';
import { ApiTimeLog } from 'src_common/server/webDriver/logFormat';


export interface ParamsType {
    requestBody: {
        confirm: string;
        email: string;
        marketing: boolean;
        newPassword: string;
        receivedVia: string;
        terms: boolean;
        token: string;
    };
}


const createGuard = <A>(code: number, decoder: t.Type<A, A, unknown>): ((data: unknown) => A) => {
    return (data: unknown): A => {
        const decodeResult = decoder.decode(data);
        if (isRight(decodeResult)) {
            return decodeResult.right;
        }
        throw Error(`Response decoding error /api-proxy/anonymous/reset-password -> post -> ${code}`);
    };
};

export const Response200IO = t.union([t.interface({
    error: t.interface({
        code: t.string,
        debugDetails: t.union([t.null, t.undefined, t.string]),
        details: t.union([t.null, t.undefined, t.string]),
        errors: t.union([t.null, t.undefined, t.array(t.interface({
            code: t.string,
            debugDetails: t.union([t.null, t.undefined, t.string]),
            field: t.string,
            pointer: t.union([t.null, t.undefined, t.string]),
            resource: t.string,
        }))]),
        message: t.string,
    }),
    status: t.literal('error'),
    type: t.literal('PasswordResetErrorResponse'),
}), t.interface({
    status: t.literal('ok'),
    type: t.literal('PasswordResetSuccessResponse'),
})]);
export type Response200Type = {
    error: {
        code: string;
        debugDetails?: null | undefined | string;
        details?: null | undefined | string;
        errors?: null | undefined | Array<{
            code: string;
            debugDetails?: null | undefined | string;
            field: string;
            pointer?: null | undefined | string;
            resource: string;
        }>;
        message: string;
    };
    status: 'error';
    type: 'PasswordResetErrorResponse';
} | {
    status: 'ok';
    type: 'PasswordResetSuccessResponse';
};
export const decodeResponse200 = createGuard(200, Response200IO);

export const Response400IO = t.string;
export type Response400Type = string;
export const decodeResponse400 = createGuard(400, Response400IO);

export const Response401IO = t.string;
export type Response401Type = string;
export const decodeResponse401 = createGuard(401, Response401IO);

export const Response500IO = t.string;
export type Response500Type = string;
export const decodeResponse500 = createGuard(500, Response500IO);



type ExtraHeadersType = Record<string, string>


/**
 * @deprecated - Please use this method "openapiProxyAnonymousPasswordResetRequest"
 */
export const openapi_proxy_anonymous_password_reset = async (api_url: string, api_timeout: number, backendToken: string, params: ParamsType, extraHeaders?: ExtraHeadersType): Promise<FetchGeneralRawResponseType> => {
    
        
    const query = '';
    const url = `${api_url}/api-proxy/anonymous/reset-password${query}`;
    
    const method = 'POST';
    const paramsFetch = {
        url,
        body: params.requestBody,
        backendToken,
        timeout: api_timeout,
        extraHeaders,
    };

    const apiTime = ApiTimeLog.createWithProcessEnv(method, url);
    const response = await fetchGeneralRaw(method, paramsFetch);
    apiTime.show(response.status);
    return response;
};


export type OpenapiProxyAnonymousPasswordResetParamsType = ParamsType;

export type OpenapiProxyAnonymousPasswordResetResponseType = {
    status: 200;
    body: Response200Type;
} | {
    status: 400;
    body: Response400Type;
} | {
    status: 401;
    body: Response401Type;
} | {
    status: 500;
    body: Response500Type;
};

export type OpenapiProxyAnonymousPasswordResetResponse200Type = Response200Type;

export const openapiProxyAnonymousPasswordResetRequest = async (api_url: string, api_timeout: number, backendToken: string, params: ParamsType, extraHeaders?: ExtraHeadersType): Promise<OpenapiProxyAnonymousPasswordResetResponseType> => {
    const response = await openapi_proxy_anonymous_password_reset(api_url, api_timeout, backendToken, params, extraHeaders);
    const { status, body } = response;

    let json = null;

    try {
        json = JSON.parse(body);
    } catch (_err) {
        console.warn(`Http status ${status} - json was expected`);
        json = {};
    }
    
    if (status === 200) {
        return { status: 200, body: decodeResponse200(json) };
    }

    if (status === 400) {
        return { status: 400, body: decodeResponse400(json) };
    }

    if (status === 401) {
        return { status: 401, body: decodeResponse401(json) };
    }

    if (status === 500) {
        return { status: 500, body: decodeResponse500(json) };
    }

    throw new Error(`openapiProxyAnonymousPasswordResetRequest - unhandled response ${response.status}`);
};

